// Style swatches — see snippets/style-swatches.liquid.
if (!customElements.get('style-swatches')) {
  customElements.define(
    'style-swatches',
    class StyleSwatches extends HTMLElement {
      connectedCallback() {
        this.links = [...this.querySelectorAll('.style-swatch')];
        // Carry the chosen Finish to the sibling: Dawn's VariantSelects sets
        // currentVariant in its own change handler, which runs before ours bubbles up.
        this.picker = this.closest('section, .product')?.querySelector('variant-selects');
        this.onVariant = () => this.sync(this.picker.currentVariant?.title);
        this.picker?.addEventListener('change', this.onVariant);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.picker?.removeEventListener('change', this.onVariant);
      }

      sync(variantTitle) {
        if (!variantTitle) return;
        for (const link of this.links) {
          const id = JSON.parse(link.dataset.variants)[variantTitle];
          link.href = id ? `${link.dataset.url}?variant=${id}` : link.dataset.url;
        }
      }

      reset() {
        this.classList.remove('is-navigating');
        for (const link of this.links) {
          const current = link.dataset.url === location.pathname;
          link.toggleAttribute('aria-current', current);
          if (current) {
            link.setAttribute('aria-current', 'page');
            this.querySelector('.style-swatches__current').textContent = link.dataset.label;
          }
        }
      }

      onClick = (event) => {
        const link = event.target.closest('.style-swatch');
        if (!link || event.defaultPrevented || event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (link.getAttribute('aria-current') === 'page') return event.preventDefault();

        // Read by the inline script on the next page so the row lands where it left.
        try {
          sessionStorage.setItem(
            'aeqea:style-anchor',
            JSON.stringify({
              top: this.getBoundingClientRect().top,
              left: this.querySelector('.style-swatches__list').scrollLeft,
              at: Date.now(),
            })
          );
        } catch (e) {}

        // Move the ring immediately: the press should feel like a variant change
        // even on a slow network where the next page takes a moment.
        this.querySelector('[aria-current="page"]')?.removeAttribute('aria-current');
        link.setAttribute('aria-current', 'page');
        this.querySelector('.style-swatches__current').textContent = link.dataset.label;
        this.classList.add('is-navigating');
      };
    }
  );
}

// Back/forward cache restores the page exactly as we left it — ring already moved.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) document.querySelectorAll('style-swatches').forEach((el) => el.reset());
});
